import React, { useEffect, useState } from 'react';
import './index.css';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './components/HomePage';
import ServiceDetailPage from './components/ServiceDetailPage';
import CrmAutomationPage from './components/CrmAutomationPage';
import SocialMediaMarketingPage from './components/SocialMediaMarketingPage';
import EmailMarketingPage from './components/EmailMarketingPage';
import GraphicDesignPage from './components/GraphicDesignPage';
import SeoPage from './components/SeoPage';
import PaidAdsPage from './components/PaidAdsPage';
import WebsiteGenerationPage from './components/WebsiteGenerationPage';
import ContentCreationPage from './components/ContentCreationPage';
import CustomCursor from './components/CustomCursor';
import FloatingWhatsAppButton from './components/FloatingWhatsAppButton';
import { servicePages } from './data/servicePages';

function App() {
  const location = useLocation();
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const savedTheme = window.localStorage.getItem('beyond-digital-theme');
    if (savedTheme === 'dark' || savedTheme === 'light') {
      setTheme(savedTheme);
      return;
    }

    const routeDefault = location.pathname === '/' ? 'dark' : 'light';
    setTheme(routeDefault);
  }, [location.pathname]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    window.localStorage.setItem('beyond-digital-theme', theme);
  }, [theme]);

  return (
    <>
      <CustomCursor />
      <FloatingWhatsAppButton />
      <button
        type="button"
        className="theme-toggle"
        aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
        onClick={() => setTheme(prev => (prev === 'dark' ? 'light' : 'dark'))}
      >
        <span className="theme-toggle__icon" aria-hidden="true">
          {theme === 'dark' ? '☀' : '☾'}
        </span>
      </button>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services/crm-automation" element={<CrmAutomationPage />} />
        <Route
          path="/services/social-media-marketing"
          element={<SocialMediaMarketingPage />}
        />
        <Route path="/services/email-marketing" element={<EmailMarketingPage />} />
        <Route path="/services/graphic-design" element={<GraphicDesignPage />} />
        <Route path="/services/seo" element={<SeoPage />} />
        <Route path="/services/paid-ads" element={<PaidAdsPage />} />
        <Route path="/services/website-generation" element={<WebsiteGenerationPage />} />
        <Route path="/services/content-creation" element={<ContentCreationPage />} />
        <Route path="/services/:serviceSlug" element={<ServiceDetailPage />} />
        <Route
          path="/services"
          element={<Navigate to={`/services/${servicePages[0].slug}`} replace />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;